import {axios, HOST, config} from './settiing';


export default {

  getLostItemList(date) {
    return axios.get(`${HOST}/resource/lostItem/date/${date}`, config);
  },
  getLostItemListByRange(start, end) {
    return axios.get(`${HOST}/resource/lostItem/range/${start}/${end}`, config);
  },
  getLostItem(id) {
    return axios.get(`${HOST}/resource/lostItem/${id}`, config);
  },
  addLostItem(data) {
    return axios.post(`${HOST}/resource/lostItem`, data, config);
  },
  updateLostItem(data) {
    return axios.put(`${HOST}/resource/lostItem`, data, config);
  },
  deleteLostItem(id) {
    return axios.delete(`${HOST}/resource/lostItem/${id}`, config);
  },
  deleteLostItems(ids) {
    return axios.post(`${HOST}/resource/lostItems/remove`, ids, config);
  }
}
